import React from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box';
import { LoggedInClient } from '../..';
import {
  receiverMenuData,
  remittanceMenuData,
  senderMenuData,
  whiteLabelMenuData
} from '../../data/dashboardData2';
import { useAccount } from '@src/contexts';
import AsideBlock from './asideBlock';

interface Props {
  client?: LoggedInClient;
}

const Aside = ({ client }: Props) => {
  const { isRemittanceBusiness, isWhiteLabelBusiness } = useAccount();

  const displayedMenuData = isWhiteLabelBusiness
    ? whiteLabelMenuData
    : isRemittanceBusiness
    ? remittanceMenuData
    : client === 'sender'
    ? senderMenuData
    : receiverMenuData;
  return (
    <Box
      as="aside"
      className="ss-w-max ss-h-max ss-hidden lg:ss-block lg:ss-w-[250px] xl:ss-w-[300px] ss-sticky ss-top-30 ss-bg-white ss-py-14 ss-px-5 ss-rounded-b-lg">
      <Box className="ss-flex ss-flex-col ss-gap-2">
        {displayedMenuData.map((item, index) => (
          <AsideBlock key={index} {...item} />
        ))}
      </Box>
    </Box>
  );
};

export default Aside;
